import React, { FCWithChildren, MouseEvent } from 'react';
import clsx from 'clsx';
import styles from '../../product-timeline.module.scss';

const UrlActionView: FCWithChildren<{
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  url: string;
  newTab: boolean;
  className: string;
  message?: string;
  disabled?: boolean;
  dataCy?: string;
}> = ({ onClick, url, newTab, className, children, message, disabled, dataCy }) => {
  return (
    <div
      data-cy={dataCy}
      className={styles.ordersSales__mainRight__steps__step__box__actions__msgBtn}
    >
      <a
        className={clsx(className, {
          [styles.ordersSales__mainRight__steps__step__box__actions__inactiveLink]: disabled,
        })}
        href={url}
        rel={'noreferrer'}
        target={newTab ? '_blank' : ''}
        onClick={onClick}
      >
        {children}
      </a>

      {!!message && (
        <div
          className={clsx(
            styles['ordersSales__mainRight__steps__step__box--text--875'],
            styles['ordersSales__mainRight__steps__step__box--text--grey'],
          )}
        >
          {message}
        </div>
      )}
    </div>
  );
};

export default UrlActionView;
